import React from 'react';
import Error from './Error';

export default function NotFound({ title = "Not Found", message = "The requested resource could not be found.", ...props }) {
    return (<Error title={title} message={message}>{ props.children }</Error>);
}